import { render, staticRenderFns } from "./form-task-priority.vue?vue&type=template&id=2eec46e5&"
import script from "./form-task-priority.vue?vue&type=script&lang=js&"
export * from "./form-task-priority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("c:\\xampp\\htdocs\\app.poojalab.com\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eec46e5')) {
      api.createRecord('2eec46e5', component.options)
    } else {
      api.reload('2eec46e5', component.options)
    }
    module.hot.accept("./form-task-priority.vue?vue&type=template&id=2eec46e5&", function () {
      api.rerender('2eec46e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/configuration/task/form-task-priority.vue"
export default component.exports